/** @jsxImportSource @emotion/react */
import React from 'react';

import { Button } from 'reactstrap';
import { ActivityIndicator } from 'react-native-web';
import { css } from '@emotion/react';
import { RightArrow } from 'Icons/Icons';

import ErrorMessage from 'Components/Common/ErrorMessage';

import colors from 'Themes/colors';
import font from 'Themes/fonts';

interface ButtonProps {
    loading?: boolean;
    error?: string;
    text: string;
    onClick(): void;
    style?: React.CSSProperties;
    disabled?: boolean;
    negative?: boolean;
    rightArrow?: boolean;
}

const CustomButton = (props: ButtonProps): JSX.Element => {
    const { loading, error, text, onClick, style, disabled, negative, rightArrow } = props;

    let buttonStyle = loading ? styles.buttonLoading : styles.button;
    if (negative) buttonStyle = loading ? styles.negativeButtonLoading : styles.negativeButton;

    if (loading) {
        return (
            <div style={{ flex: 1, justifyContent: 'center', alignItems: 'center' }}>
                <ActivityIndicator size='small' />
            </div>
        );
    }

    return (
        <div>
            <ErrorMessage error={error} style={style} />
            <Button css={buttonStyle} onClick={onClick} style={style} disabled={disabled}>
                {text}
                {rightArrow && <RightArrow css={styles.rightArrow} />}
            </Button>
        </div>
    );
};

CustomButton.defaultProps = {
    loading: false,
    error: '',
    style: {},
    disabled: false,
    negative: false,
    rightArrow: false,
};

const styles = {
    button: css({
        display: 'flex',
        fontSize: 18,
        fontFamily: font.primary,
        color: colors.white,
        backgroundColor: '#064E72',
        border: '2px solid #064E72',
        borderRadius: '5px',
        padding: '8px',
        height: 48,
        width: '100%',
        transition: 'ease 0.2s',
        justifyContent: 'center',
        alignItems: 'center',
        '&:hover': {
            backgroundColor: colors.white,
            border: '2px solid #064E72',
            color: '#064E72',
        },
        '&:focus': {
            backgroundColor: '#064E72',
            border: '2px solid #064E72',
            color: colors.white,
        },
    }),
    buttonLoading: css({
        display: 'flex',
        fontSize: 18,
        fontFamily: font.primary,
        color: colors.white,
        backgroundColor: '#064E72',
        border: '2px solid #064E72',
        borderRadius: '5px',
        padding: '8px',
        height: 48,
        width: '100%',
        transition: 'ease 0.2s',
        justifyContent: 'center',
        alignItems: 'center',
        '&:hover': {
            backgroundColor: '#064E72',
            border: `2px solid ${colors.white}`,
            color: colors.white,
        },
        '&:focus': {
            backgroundColor: '#064E72',
            border: `2px solid ${colors.white}`,
            color: colors.white,
        },
        '&:active': {
            backgroundColor: '#064E72',
            border: '2px solid #064E72',
            color: colors.white,
        },
    }),
    negativeButton: css({
        fontSize: 18,
        fontFamily: font.primary,
        color: colors.white,
        backgroundColor: '#064E72',
        border: `2px solid ${colors.white}`,
        borderRadius: '5px',
        padding: '8px',
        height: 48,
        width: '100%',
        transition: 'ease 0.2s',
        justifyContent: 'center',
        alignItems: 'center',
        '&:hover': {
            backgroundColor: '#064E72',
            border: `2px solid ${colors.white}`,
            color: colors.white,
        },
        '&:focus': {
            backgroundColor: '#064E72',
            border: `2px solid ${colors.white}`,
            color: colors.white,
        },
        '&:active': {
            backgroundColor: '#064E72',
            border: '2px solid #064E72',
            color: colors.white,
        },
    }),
    negativeButtonLoading: css({
        display: 'flex',
        fontSize: 18,
        fontFamily: font.primary,
        color: colors.white,
        backgroundColor: '#064E72',
        border: `2px solid ${colors.white}`,
        borderRadius: '5px',
        padding: '8px',
        height: 48,
        width: '100%',
        transition: 'ease 0.2s',
        justifyContent: 'center',
        alignItems: 'center',
    }),
    rightArrow: css({
        marginLeft: 10,
        alignItems: 'center',
        alignSelf: 'center',

    }),
};

export default CustomButton;
